var _g, _rect, _rect2, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _g2, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _rect3, _g3, _rect4, _rect5, _rect6, _path30, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInfoCircles(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 252,
    height: 75,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#infoCircles_svg__clip0_685_4240)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 75,
    height: 75,
    rx: 37.5,
    fill: "#F8D763"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.388 8.329s15.437-4.87 23.453 9.003c5.172 8.953-2.019 19.71-6.12 21.202-6.707-1.242-13.784 5.47-13.784 5.47l-5.713 9.439s-13.877-6.434-14.407-21.61c-.743-21.36 16.571-23.506 16.571-23.506v.002z",
    fill: "#F3F4F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.14 52.567s-2.73 6.983-.743 12.697c-6.956 5.466-13.784 1.694-13.784 1.694l-7.825-4.681s6.707-9.338 2.731-25.779c0-5.852 13.024-2.824 13.024-2.824",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.14 52.567s-2.73 6.983-.743 12.697c-6.956 5.466-13.784 1.694-13.784 1.694l-7.825-4.681s6.707-9.338 2.731-25.779c0-5.852 13.024-2.824 13.024-2.824",
    stroke: "#333",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.61 44.627s2.54 12.454 12.667 12.42c9.349-.03 11.53-7.714 13.04-19.995 1.523-12.38-2.61-18.954-2.61-18.954L30.98 15.94",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.61 44.627s2.54 12.454 12.667 12.42c9.349-.03 11.53-7.714 13.04-19.995 1.523-12.38-2.61-18.954-2.61-18.954L30.98 15.94",
    stroke: "#333",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.899 33.231s-4.479-5.326-6.715-1.847c-2.234 3.478.924 11.13.924 11.13l-3.23 1.49",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.899 33.231s-4.479-5.326-6.715-1.847c-2.234 3.478.924 11.13.924 11.13l-3.23 1.49",
    stroke: "#333",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.639 30.32s-5.098-.906-8.931 1.877l8.93-1.878z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.639 30.32s-5.098-.906-8.931 1.877",
    stroke: "#333",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.915 35.649s-2.037-2.37-4.623-.088l4.623.088z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.915 35.649s-2.037-2.37-4.623-.088",
    stroke: "#333",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.395 35.56s-3.13-3.113-7.65-.313l7.65.312z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.395 35.56s-3.13-3.113-7.65-.313",
    stroke: "#333",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.18 35.56c0 .823.475 1.137 1.023 1.137.548 0 .963-.316.963-1.138 0-.821-.444-1.49-.993-1.49-.548 0-.992.667-.992 1.49zM50.853 35.933c0 .755.39 1.04.869 1.04.477 0 .87-.287.87-1.04 0-.753-.39-1.366-.87-1.366s-.869.61-.869 1.366z",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.828 22.028s-8.92 5.846-19.6 3.19c0 0-.957 7.034-4.62 8.85-3.477-2.43-4.096-10.572-4.096-10.572l4.097-9.464 25.708 3.393-1.49 4.603z",
    fill: "#F3F4F8"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.58,
    d: "M33.963 29.824s-1.781-3.097-5.198-2.502c-3.415.595-2.48-4.766-6.982-3.941-3.646.67-2.737-1.575-2.737-1.575s-.939 2.701-1.15 6.035c.691.67 2.697-2.153 4.889-1.186 2.191.964.652 3.762 4.188 4.534 3.538.77 3.201 4.592 3.201 4.592s2.567-2.59 3.787-5.953l.002-.004z",
    fill: "#D9D9DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.63 34.515c-1.028-3.681-3.873-6.103-6.353-5.41-2.48.693-3.654 4.238-2.625 7.92 1.028 3.68 3.873 6.102 6.353 5.409",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.63 34.515c-1.028-3.681-3.873-6.103-6.353-5.41-2.48.693-3.654 4.238-2.625 7.92 1.028 3.68 3.873 6.102 6.353 5.409",
    stroke: "#333",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.833 36.742s-1.27-5.93-5.72-4.237l5.72 4.237z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.833 36.742s-1.27-5.93-5.72-4.237",
    stroke: "#333",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.505 39.285s-2.803-3.01-1.19-7.012l1.19 7.012z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.505 39.285s-2.803-3.01-1.19-7.012",
    stroke: "#333",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.882 36.785s-.846 1.067-2.467 1.175l2.467-1.175z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.882 36.785s-.846 1.067-2.467 1.175",
    stroke: "#333",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.294 36.65s.61 1.056 1.775 1.1l-1.775-1.1z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.294 36.65s.61 1.056 1.775 1.1",
    stroke: "#333",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.37 47.747s-3.912.212-6.72-1.703l6.72 1.703z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.37 47.747s-3.912.212-6.72-1.703M43.247 44.819s-1.44 1.065-.906 3.355M55.395 21.024s-7.509 7.966-23.143 3.028",
    stroke: "#333",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.14 59.102l-3.634.15-1.333 6.557-2.255-6.707-13.802-3.727-4.533 8.646-26.533 7.006V83.25H72.48a28.9 28.9 0 00-17.525-14.546l-8.075-2.387-1.738-7.215h-.002z",
    fill: "#FF755F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.918 59.102l2.255 6.707.993 11.87",
    stroke: "#333",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: 1.5,
    width: 72,
    height: 72,
    rx: 36,
    stroke: "#fff",
    strokeWidth: 3
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#infoCircles_svg__clip1_685_4240)"
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 59,
    width: 75,
    height: 75,
    rx: 37.5,
    fill: "#FF755F"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M101.376 8.38s-16.149-4.964-23.944 8.681c-7.796 13.642-1.462 24.85-1.462 24.85s-.328-2.92 1.298-6.09c.163 4.14 3.087 7.795 7.108 9.257 6.578-1.218 13.52-1.705 13.52-1.705l5.602 9.257s13.611-6.31 14.131-21.196c.729-20.95-16.253-23.051-16.253-23.051V8.38z",
    fill: "#333"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M110.688 58.233a8.65 8.65 0 008.649-8.65 8.65 8.65 0 10-8.649 8.65z",
    fill: "#333"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M92.675 52.072s3.028 6.404 1.077 12.007c6.823 5.36 11.328 1.803 11.328 1.803l4.994-4.726s-5.116-6.688 0-25.147c0-5.74-12.773-2.77-12.773-2.77",
    fill: "#fff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M92.675 52.072s3.028 6.404 1.077 12.007c6.823 5.36 11.328 1.803 11.328 1.803l4.994-4.726s-5.116-6.688 0-25.147c0-5.74-12.773-2.77-12.773-2.77",
    stroke: "#333",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M105.085 43.982s-3.534 12.79-12.424 12.182c-6.845-.469-8.77-7.308-11.45-19.247-2.679-11.939 1.218-18.957 1.218-18.957l22.291-2.117",
    fill: "#fff"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M105.085 43.982s-3.534 12.79-12.424 12.182c-6.845-.469-8.77-7.308-11.45-19.247-2.679-11.939 1.218-18.957 1.218-18.957l22.291-2.117",
    stroke: "#333",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M90.945 50.838c1.422-.09 2.498-1.4 2.401-2.932-.094-1.53-1.325-2.698-2.747-2.609-1.422.09-2.498 1.402-2.402 2.932.095 1.53 1.326 2.698 2.746 2.609h.002z",
    fill: "#FFA494"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M81.088 31.192s3.411-2.923 5.605.488c2.191 3.412-.73 10.233-.73 10.233l3.167 1.462",
    fill: "#fff"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M81.088 31.192s3.411-2.923 5.605.488c2.191 3.412-.73 10.233-.73 10.233l3.167 1.462",
    stroke: "#333",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M90.834 30.216s4.872-2.437 8.633.296l-8.633-.296z",
    fill: "#fff"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M90.834 30.216s4.872-2.437 8.633.296",
    stroke: "#333",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M81.245 35.176s1.998-2.323 4.535-.086l-4.535.086z",
    fill: "#fff"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M81.245 35.176s1.998-2.323 4.535-.086",
    stroke: "#333",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M91.564 35.09s3.07-3.052 7.502-.308l-7.502.308z",
    fill: "#fff"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M91.564 35.09s3.07-3.052 7.502-.308",
    stroke: "#333",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M94.407 45.895c.876 1.143-1.112 3.355-3.564 3.63-2.453.276-4.393-1.491-3.793-2.8.566-1.242 1.43.087 3.46-.142 2.034-.228 3.071-1.77 3.9-.688h-.003z",
    fill: "#333"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "infoCircles_svg__a",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 86,
    y: 45,
    width: 9,
    height: 5
  }, _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M94.407 45.895c.876 1.143-1.112 3.355-3.564 3.63-2.453.276-4.393-1.491-3.793-2.8.566-1.242 1.43.087 3.46-.142 2.034-.228 3.071-1.77 3.9-.688h-.003z",
    fill: "#fff"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#infoCircles_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M94.001 55.064a4.14 4.14 0 10.001-8.28 4.14 4.14 0 00-.001 8.28z",
    fill: "#FF8773"
  }))), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M95.706 36.553c.538 0 .974-.655.974-1.463s-.436-1.462-.974-1.462-.975.654-.975 1.462c0 .808.435 1.462.975 1.462zM84.377 36.797c.47 0 .851-.6.851-1.34 0-.74-.38-1.34-.851-1.34-.47 0-.852.6-.852 1.34 0 .74.381 1.34.852 1.34zM81.33 21.819s8.77 11.754 25.095 10.077c3.411-2.383 2.678-8.637 2.678-8.637l-2.678-7.485-26.555 1.534 1.462 4.514h-.001v-.003z",
    fill: "#333"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M104.116 33.258c1.185-4.234 4.453-7.02 7.306-6.221 2.85.799 4.203 4.874 3.02 9.107-1.186 4.234-4.453 7.02-7.306 6.221",
    fill: "#fff"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M104.116 33.258c1.185-4.234 4.453-7.02 7.306-6.221 2.85.799 4.203 4.874 3.02 9.107-1.186 4.234-4.453 7.02-7.306 6.221",
    stroke: "#333",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M106.181 35.82s1.462-6.823 6.578-4.872l-6.578 4.871z",
    fill: "#fff"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M106.181 35.82s1.462-6.823 6.578-4.872",
    stroke: "#333",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M108.86 38.744s3.222-3.46 1.368-8.066l-1.368 8.066z",
    fill: "#fff"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M108.86 38.744s3.222-3.46 1.368-8.066",
    stroke: "#333",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M81.817 43.13c2.826 0 5.117-2.945 5.117-6.58 0-3.633-2.29-6.578-5.117-6.578-2.826 0-5.116 2.947-5.116 6.579 0 3.632 2.29 6.578 5.116 6.578zM95.706 43.13c2.824 0 5.116-2.945 5.116-6.58 0-3.633-2.29-6.578-5.116-6.578-2.826 0-5.116 2.947-5.116 6.579 0 3.632 2.29 6.578 5.116 6.578z",
    fill: "#1896EA"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M108.25 44.591a1.828 1.828 0 000-3.654 1.828 1.828 0 000 3.654z",
    fill: "#FFDF4E"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M86.934 36.55s1.704-.973 3.655 0M100.789 35.82l3.836-4.014",
    stroke: "#333",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M93.512 59.207s8.039 1.017 15.349-3.025c.342.85.729 7.897 10.752 10.234 5.918 1.379 16.779 4.73 18.484 13.987 0 5.36-.489 5.847-.489 5.847H66.5s.212-13.157 11.177-16.809c10.963-3.656 16.568-3.167 15.835-10.23v-.004z",
    fill: "#fff"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M93.512 59.207s5.116 1.504 15.348-3.025",
    stroke: "#333",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 60.5,
    y: 1.5,
    width: 72,
    height: 72,
    rx: 36,
    stroke: "#fff",
    strokeWidth: 3
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#infoCircles_svg__clip2_685_4240)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 118,
    width: 75,
    height: 75,
    rx: 37.5,
    fill: "#008AE9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.602 49.944l-1.014 9.798-4.817 6.623L156.64 71.5l16.42-4.403-6.386-5.207.612-15.727",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.602 49.944l-1.014 9.798-4.817 6.623L156.64 71.5l16.42-4.403-6.386-5.207.612-15.727",
    stroke: "#333",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.204 45.343c.23.007 4.364-10.185 5.909-11.095 1.002-.591 4.464-1.71 5.129-7.031.359-2.881-1.75-4.659-3.566-4.703-1.415-.035-2.35-2.688-2.35-2.688s-4.542 13.747-5.304 18.99c-.761 5.24.184 6.532.184 6.532v-.005h-.002z",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.007 33.347c-.032.089.063.169.147.123.857-.496 3.605-1.78 4.83 1.283 1.191 2.977-.581 7.144-2.903 8.909-2.556 1.94-4.243.803-4.243.803-3.286 11.88-17.245 15.67-23.977 8.774-4.869-4.987-4.089-11.371-4.089-11.371-5.956-3.367-4.769-11.732-2.053-12.313 1.215-.26 1.857.306 2.142.693.053.072.168.034.165-.056-.053-1.184-.007-4.944 2.321-8.631 3.833-6.07 10.227-8.385 17.363-6.512 5.085 1.332 9.321 4.142 10.413 9.171 1.111 5.113.222 8.21-.117 9.126l.001.001z",
    fill: "#fff",
    stroke: "#333",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.917 44.416s2.706-2.97 6.42-.654c2.573-1.42 6.292 1.617 6.292 1.617s-6.94 3.975-12.712-.96v-.002z",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.223 32.73s1.296-.05 2.552 1.49M140.952 39.416s-1.121-3.473-.518-6.333",
    stroke: "#333",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.809 29.931s.118 4.536-1.708 7.386c-1.03 1.608-1.706 1.424-2.166 2.65-.417 1.11.458 2.402 1.78 2.402 1.047 0 1.161-.448 1.934-.476.753-.025.827.546 1.491.447 1.005-.15.463-1.253.463-1.253",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.294 31.49s.118 4.536-1.709 7.386c-1.029 1.607-1.705 1.425-2.165 2.65-.419 1.11.458 2.402 1.78 2.402 1.047 0 1.161-.448 1.933-.476.754-.025.826.546 1.49.447 1.006-.15.464-1.252.464-1.252",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.294 31.49s.118 4.536-1.709 7.386c-1.029 1.607-1.705 1.425-2.165 2.65-.419 1.11.458 2.402 1.78 2.402 1.047 0 1.161-.448 1.933-.476.754-.025.826.546 1.49.447 1.006-.15.464-1.252.464-1.252M156.233 36.165s3.169-2.368 5.991.601M150.829 35.785s-2.423-3.232-5.846-.55",
    stroke: "#333",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.266 30.955c.782-.157 1.582-.107 2.358.036 1.455.274 2.78.95 3.917 1.874.253.186.557.496.795.705.247.25.484.513.723.767.317.35-.152.847-.52.552-.264-.22-.518-.443-.782-.658-.24-.167-.552-.414-.801-.555l-.414-.249c-.951-.535-2.036-.9-3.116-.973-.544-.037-1.107-.01-1.631.13a.856.856 0 11-.529-1.627v-.002zM150.11 32.265c-.469-.3-1.043-.484-1.592-.598-1.02-.216-2.119-.155-3.145.073-.088.02-.489.135-.582.16-.278.07-.646.229-.922.321-.31.133-.617.283-.929.423-.431.189-.754-.42-.352-.67.429-.266.915-.57 1.375-.785.158-.08.315-.166.482-.227.1-.043.53-.216.623-.252a11.58 11.58 0 011.442-.39c1.274-.229 2.654-.196 3.895.23.211.073.39.141.598.253a.857.857 0 01-.893 1.462z",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.712 37.985s1.382-1.98 3.66-1.65M172.125 42.069s1.779-2.997 1.9-5.667",
    stroke: "#333",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.824 13.45a.479.479 0 01-.477.626c-1.733-.085-5.824.042-7.436 2.91-2.836 5.046 2.396 7.42 2.396 7.42s-2.103 5.87 1.745 6.168c3.847.298 7.285-3.815 7.285-3.815s-.6 3.409 6.031 2.753c5.999-.596 9.65-4.031 9.65-4.031s-.555 1.54 1.058 1.407c1.614-.133 4.309-2.135 4.309-2.135s-4.307 13.467-2.792 15.111c1.523 1.655 4.632-6.348 4.557-6.396 4.848-3.975 4.277-11.1 3.374-13.59-1.068-2.96-3.173-7.216-7.505-7.01-1.937.094-2.818.666-3.217 1.187a.523.523 0 01-.857-.017c-.615-.921-1.816-2.42-3.883-3.903-2.472-1.777-8.313-2.777-11.141-1.383-3.445 1.696-3.416 3.678-3.099 4.7h.002v-.001z",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.024 29.18s-1.405 10.05-.099 8.81c.827-.784 1.675-9.516 1.675-9.516l-1.578.706h.002z",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.21,
    fill: "#34A3FA"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M146.213 40.993c2.483.062 4.558-2.48 4.64-5.677.08-3.196-1.868-5.838-4.352-5.9-2.482-.061-4.557 2.48-4.639 5.676-.08 3.198 1.867 5.839 4.351 5.9v.002zM159.5 42.621c2.483.061 4.56-2.479 4.64-5.675.08-3.198-1.868-5.84-4.352-5.9-2.482-.062-4.557 2.48-4.639 5.676-.08 3.197 1.867 5.84 4.351 5.9v-.001z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M146.222 40.852c2.483.062 4.558-2.48 4.64-5.675.08-3.196-1.868-5.839-4.352-5.9-2.482-.062-4.557 2.479-4.637 5.675-.081 3.198 1.867 5.839 4.351 5.9h-.002zM159.51 42.48c2.482.06 4.558-2.481 4.639-5.676.081-3.198-1.867-5.839-4.351-5.9-2.482-.061-4.558 2.48-4.639 5.675-.08 3.197 1.867 5.839 4.351 5.9zM150.841 36.097c.335.082 1.557-1.183 4.324.273M164.1 35.765c.213-.043 8.777-3.17 8.958-3.111",
    stroke: "#FF8773",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.109 36.49c.561 0 1.014-.546 1.014-1.22 0-.672-.453-1.217-1.014-1.217-.56 0-1.013.545-1.013 1.218 0 .673.453 1.218 1.013 1.218zM159.652 37.62c.561 0 1.014-.545 1.014-1.218 0-.673-.453-1.218-1.014-1.218-.56 0-1.013.545-1.013 1.218 0 .673.453 1.218 1.013 1.218z",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.355 47.132s3.014 2.622 7.393.034l-7.393-.034z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.355 47.132s3.014 2.622 7.393.034",
    stroke: "#333",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.568 59.105l9.58 6.47 12.574-4.814 27.495 11.981.955 10.388h-76.29l-.382-13.511 26.069-10.516-.001.002z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.567 59.105l9.581 6.47 12.574-4.814",
    stroke: "#333",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.284 60.83l6.115 11.268 7.716-5.805 7.872 6.834 8.357-10.789M155.099 66.55v16.154",
    stroke: "#333",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 119.5,
    y: 1.5,
    width: 72,
    height: 72,
    rx: 36,
    stroke: "#fff",
    strokeWidth: 3
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 178.5,
    y: 1.5,
    width: 72,
    height: 72,
    rx: 36,
    fill: "#35B3A9"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 178.5,
    y: 1.5,
    width: 72,
    height: 72,
    rx: 36,
    stroke: "#fff",
    strokeWidth: 3
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M227.466 30.895a.75.75 0 010 1.063l-14.862 14.795a.75.75 0 01-1.027.029l-10.782-9.571a.749.749 0 01-.077-1.042l1.693-2.023a.75.75 0 011.079-.075l8.359 7.58 12.682-12.624a.75.75 0 011.058 0l1.877 1.868z",
    fill: "#fff"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "infoCircles_svg__clip0_685_4240"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 75,
    height: 75,
    rx: 37.5,
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "infoCircles_svg__clip1_685_4240"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 59,
    width: 75,
    height: 75,
    rx: 37.5,
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "infoCircles_svg__clip2_685_4240"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 118,
    width: 75,
    height: 75,
    rx: 37.5,
    fill: "#fff"
  })))));
}
export default __webpack_public_path__ + "static/infoCircles.990338a7.svg";
export { SvgInfoCircles as ReactComponent };